var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgAddress(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.84 3.462a6.49 6.49 0 00-5.245-2.156C7.99 1.532 5.356 4.74 5.498 8.349a15.62 15.62 0 001.307 5.56 19.253 19.253 0 004.425 6.285 1.131 1.131 0 001.54 0c3.316-3.13 5.736-7.665 5.736-12.389a6.468 6.468 0 00-1.666-4.343zm-5.531 7.781a3.523 3.523 0 111.36-6.914 3.523 3.523 0 01-1.36 6.914z",
    fill: "#F58787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.56 20.664l-1.904-1.974a2.904 2.904 0 00-2.087-.88h-2.427a.658.658 0 00-.65.922.657.657 0 00.65.395h2.427a1.59 1.59 0 011.14.475l1.886 1.973a.211.211 0 01.05.249.267.267 0 01-.264.166H2.604a.268.268 0 01-.264-.166.207.207 0 01.05-.249l1.902-1.973a1.59 1.59 0 011.14-.475h2.427a.658.658 0 00.65-.921.66.66 0 00-.65-.396H5.432a2.905 2.905 0 00-2.087.88L1.44 20.664a1.52 1.52 0 00-.314 1.675 1.594 1.594 0 001.477.965h18.794a1.594 1.594 0 001.477-.965 1.52 1.52 0 00-.314-1.675z",
    fill: "#82ED82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.84 3.462l-2.09 2.171a3.51 3.51 0 10-4.815 5.029L6.792 13.92a15.62 15.62 0 01-1.307-5.56c-.129-3.62 2.505-6.83 6.11-7.055a6.49 6.49 0 015.245 2.156z",
    fill: "#F99"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1.305)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgAddress;